import React, { useEffect, useState } from 'react';
import { prefersReducedMotion } from '../lib/motion';

/**
 * Types out a shell command character by character, then calls onDone.
 * Renders as: ➜ ~ <typed text><blinking cursor>
 */
const TypedCommand: React.FC<{ command: string; speed?: number; onDone?: () => void }> = ({
  command,
  speed = 55,
  onDone
}) => {
  const [count, setCount] = useState(() => (prefersReducedMotion() ? command.length : 0));

  useEffect(() => {
    if (count >= command.length) {
      if (onDone) onDone();
      return;
    }
    const t = setTimeout(() => setCount(c => c + 1), speed);
    return () => clearTimeout(t);
  }, [count, command, speed, onDone]);

  return (
    <p className="prompt-line" style={{ fontSize: '1rem' }}>
      <em>{command.slice(0, count)}</em>
      {count < command.length && <span className="cursor" />}
    </p>
  );
};

export default TypedCommand;
